"use client";

import ThreadCommentSection from "@/components/community/ThreadCommentSection";

interface IssueCommentSectionProps {
  /** `communityIssueCommentSlug(issueId)` — `community/issues/<id>` */
  slug: string;
}

/**
 * JCG-3029: 이슈 게시판 스레드용 댓글 섹션. 공용 `ThreadCommentSection` 에 이슈용 안내 문구만 얹는다.
 */
export default function IssueCommentSection({ slug }: IssueCommentSectionProps) {
  return (
    <ThreadCommentSection
      slug={slug}
      emptyText="아직 댓글이 없어요. 추가 설명이나 같은 증상이 있으면 남겨주세요."
    />
  );
}
